import { render, staticRenderFns } from "./StatsStocks.vue?vue&type=template&id=58b244cc&scoped=true&"
import script from "./StatsStocks.vue?vue&type=script&lang=js&"
export * from "./StatsStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b244cc",
  null
  
)

export default component.exports